{% block prems_info_banner %}
    <div id="prems-info-banner"></div>
{% endblock %}